(function () {
	'use strict';

	var activeModal = null;
	var activeTrigger = null;
	var focusableSelector = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
	var modalTransitionDuration = 320;

	document.addEventListener( 'click', function ( event ) {
		var trigger = event.target.closest( '.gardp-team-card__trigger' );
		if ( trigger ) {
			openModalById( trigger.getAttribute( 'data-team-modal-target' ), trigger, true );
			return;
		}

		var closeButton = event.target.closest( '[data-team-modal-close]' );
		if ( closeButton ) {
			closeActiveModal( true );
			return;
		}

		var shareButton = event.target.closest( '[data-team-modal-share]' );
		if ( shareButton ) {
			shareModalLink( shareButton );
			return;
		}

		if ( activeModal && event.target === activeModal ) {
			closeActiveModal( true );
		}
	} );

	document.addEventListener( 'keydown', function ( event ) {
		if ( ! activeModal ) {
			return;
		}

		if ( 'Escape' === event.key ) {
			event.preventDefault();
			closeActiveModal( true );
			return;
		}

		if ( 'Tab' === event.key ) {
			trapFocus( event );
		}
	} );

	window.addEventListener( 'hashchange', function () {
		syncModalToHash();
	} );

	document.addEventListener( 'DOMContentLoaded', function () {
		syncModalToHash();
	} );

	function openModalById( modalId, trigger, updateHash ) {
		if ( ! modalId ) {
			return false;
		}

		var modal = document.getElementById( modalId );
		if ( ! modal || ! modal.classList || ! modal.classList.contains( 'gardp-team-modal' ) ) {
			return false;
		}

		if ( activeModal && activeModal !== modal ) {
			finalizeModalClose( activeModal );
		}

		activeModal = modal;
		activeTrigger = trigger || document.querySelector( '.gardp-team-card__trigger[data-team-modal-target="' + modalId + '"]' );
		clearModalCloseTimer( activeModal );
		activeModal.hidden = false;
		window.requestAnimationFrame( function () {
			if ( activeModal === modal ) {
				activeModal.classList.add( 'is-active' );
			}
		} );
		document.body.classList.add( 'gardp-team-modal-open' );

		var closeButton = activeModal.querySelector( '[data-team-modal-close]' );
		if ( closeButton ) {
			closeButton.focus();
		}

		if ( updateHash && window.location.hash.replace( /^#/, '' ) !== modalId ) {
			history.replaceState( null, '', buildRelativeUrl( modalId ) );
		}

		return true;
	}

	function closeActiveModal( updateHash ) {
		if ( ! activeModal ) {
			return;
		}

		var closingModal = activeModal;
		var closingTrigger = activeTrigger;

		closingModal.classList.remove( 'is-active' );
		document.body.classList.remove( 'gardp-team-modal-open' );

		if ( updateHash && window.location.hash.replace( /^#/, '' ) === closingModal.id ) {
			history.replaceState( null, '', window.location.pathname + window.location.search );
		}

		activeModal = null;
		activeTrigger = null;

		clearModalCloseTimer( closingModal );
		closingModal.__teamModalCloseTimer = window.setTimeout( function () {
			finalizeModalClose( closingModal );
		}, modalTransitionDuration );

		if ( closingTrigger && typeof closingTrigger.focus === 'function' ) {
			closingTrigger.focus();
		}
	}

	function clearModalCloseTimer( modal ) {
		if ( modal && modal.__teamModalCloseTimer ) {
			window.clearTimeout( modal.__teamModalCloseTimer );
			modal.__teamModalCloseTimer = null;
		}
	}

	function finalizeModalClose( modal ) {
		if ( ! modal ) {
			return;
		}

		clearModalCloseTimer( modal );
		modal.classList.remove( 'is-active' );
		modal.hidden = true;
	}

	function trapFocus( event ) {
		var focusable = Array.prototype.slice.call( activeModal.querySelectorAll( focusableSelector ) ).filter( function ( element ) {
			return ! element.hasAttribute( 'hidden' ) && element.offsetParent !== null;
		} );

		if ( ! focusable.length ) {
			event.preventDefault();
			return;
		}

		var first = focusable[0];
		var last = focusable[ focusable.length - 1 ];

		if ( event.shiftKey && document.activeElement === first ) {
			event.preventDefault();
			last.focus();
		} else if ( ! event.shiftKey && document.activeElement === last ) {
			event.preventDefault();
			first.focus();
		}
	}

	function shareModalLink( button ) {
		var modal = button.closest( '.gardp-team-modal' );
		if ( ! modal ) {
			return;
		}

		var shareUrl = window.location.origin + buildRelativeUrl( modal.id );
		var memberName = modal.getAttribute( 'data-member-name' ) || document.title;

		if ( navigator.share ) {
			navigator.share( {
				title: memberName,
				url: shareUrl
			} ).catch( function () {
				// Ignore cancelled shares.
			} );
			return;
		}

		if ( navigator.clipboard && navigator.clipboard.writeText ) {
			navigator.clipboard.writeText( shareUrl ).then( function () {
				flashShareState( button );
			} ).catch( function () {
				window.prompt( ( window.gardpTeamMembers && window.gardpTeamMembers.copyPrompt ) || 'Copy this link', shareUrl );
			} );
			return;
		}

		window.prompt( ( window.gardpTeamMembers && window.gardpTeamMembers.copyPrompt ) || 'Copy this link', shareUrl );
	}

	function flashShareState( button ) {
		var originalLabel = button.getAttribute( 'data-original-label' );
		if ( ! originalLabel ) {
			originalLabel = button.querySelector( 'span' ).textContent;
			button.setAttribute( 'data-original-label', originalLabel );
		}

		button.querySelector( 'span' ).textContent = ( window.gardpTeamMembers && window.gardpTeamMembers.copiedLabel ) || 'Copied';

		window.setTimeout( function () {
			var label = button.getAttribute( 'data-original-label' );
			if ( label ) {
				button.querySelector( 'span' ).textContent = label;
			}
		}, 1600 );
	}

	function syncModalToHash() {
		var modalId = window.location.hash.replace( /^#/, '' );

		if ( ! modalId ) {
			if ( activeModal ) {
				closeActiveModal( false );
			}
			return;
		}

		if ( ! openModalById( modalId, document.querySelector( '.gardp-team-card__trigger[data-team-modal-target="' + modalId + '"]' ), false ) && activeModal ) {
			closeActiveModal( false );
		}
	}

	function buildRelativeUrl( modalId ) {
		return window.location.pathname + window.location.search + '#' + modalId;
	}
})();